module.exports = __webpack_public_path__ + "img/file-circle-check-solid-full.34796402.svg";